import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getMessageLogList = async (token, page = 1, per_page = 50) => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/v1/admin/message_logs?page=${page}&per_page=${per_page}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      toast.error(data?.status?.message || "something went wrong");
    }
  } catch (error) {
    toast.error(error.message || "something went wrong");
  }
};
